import Box from '@mui/material/Box';
import * as React from 'react';
import {useState} from 'react';
import {TabPanel} from '../../components/other/tabPanel';
import {useTranslation} from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import {StyledTab, StyledTabs} from './admin';
import PtCardCfg from './aglyeConfig/ptCardCfg';
import BedCleaningRequestCfg from './aglyeConfig/bedCleaningRequestCfg';
import RegistrationCfg from './aglyeConfig/registrationCfg';
import PatientCfg from './aglyeConfig/patientCfg';
import ObsCfg from './aglyeConfig/obsCfg';
import {getConfig} from '../../util/configUtil';

export const useAgyleConfigStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: '#448FFF',
    },
    paper: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 4,
        marginBottom: 10,
        padding: 10,
    },
    currentOpt: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    label: {
        fontWeight: 'bold',
        fontSize: 'large',
    },
    action: {
        marginTop: 10,
        display: 'flex',
        gap: 5,
        justifyContent: 'flex-end',
    },
    table: {
        maxHeight: '400px !important',
    },
    smallContext: {
        backgroundColor: theme.palette.mode === 'light' ? '#e3e3e3' : '#434343',
        margin: '10px 0',
        padding: 10,
        borderRadius: 6,
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    radioButtons: {
        marginTop: 10,
        marginLeft: 5,
    },
    header: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginBottom: 10,
        width: '100%',
        gap: 10,
    },
}));

const CONFIG_LIST = [
    {id: 'card.flashing', description: 'Patient Card Flashing', ctx: PtCardCfg, active: true},
    {id: 'bed.cleaning.request', description: 'Cleaning Bed Request', ctx: BedCleaningRequestCfg, active: getConfig('modules.cleaningRequest.enabled', false)},
    {id: 'registration', description: 'Registration', ctx: RegistrationCfg, active: true},
    {id: 'patients', description: 'Patients', ctx: PatientCfg, active: true},
    {id: 'observations', description: 'Observations', ctx: ObsCfg, active: getConfig('observations.retrospective', false)},
];

function AgyleConfiguration(props) {
    const classes = useAgyleConfigStyles();
    const {t} = useTranslation();

    const [tab, setTab] = useState(CONFIG_LIST[0]?.id);
    const moduleList = CONFIG_LIST.filter(cfg => cfg.active);

    const handleChangeTab = (event, newValue) => {
        setTab(newValue);
    };

    return (
        <>
            <Box sx={{width: '100%'}}>
                <Box sx={{borderBottom: 1, borderColor: 'divider', display: 'flex'}}>
                    <StyledTabs
                        value={tab}
                        TabIndicatorProps={{className: classes.indicator}}
                        onChange={handleChangeTab}
                    >
                        {moduleList.map(cfg => (
                            <StyledTab
                                key={cfg.id}
                                value={cfg.id}
                                label={t(cfg.description)}
                            />
                        ))}
                    </StyledTabs>
                </Box>

                {moduleList.map(cfg => (
                    <TabPanel
                        key={cfg.id}
                        value={tab}
                        index={cfg.id}
                    >
                        {React.createElement(cfg.ctx, {
                            context: cfg,
                        })}
                    </TabPanel>
                ))}
            </Box>
        </>
    );
}

export default AgyleConfiguration;